import type React from "react";
import { Typography, Grid, useTheme } from "@mui/material";
import { tokens } from "../../../theme";

interface InfoRowProps {
  label: string;
  value: string | number | React.ReactNode;
}

const InfoRow: React.FC<InfoRowProps> = ({ label, value }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <Grid sx={{ mr: 2 }} size={{ xs: 12 }}>
      <Typography
        sx={{ color: colors.primary[300] }}
        variant="body2"
        gutterBottom
      >
        {label}
      </Typography>
      <Typography variant="body1">{value}</Typography>
    </Grid>
  );
};

export default InfoRow;
